import { EsportIcon, FootballIcon, MmaIcon, MotorsportIcon, RugbyIcon, TennisIcon } from '@capsicum/common-web/icons';
import styled from 'styled-components';

export const SportIcons = ({ color, ...props }: { color: string }) => {
	const sportIcons = [FootballIcon, RugbyIcon, EsportIcon, MmaIcon, TennisIcon, MotorsportIcon];
	const iconSizeLength = '40px';

	return (
		<S.IconsInnerView {...props}>
			{sportIcons.map(SportIcon => (
				<SportIcon
					color={color}
					height={iconSizeLength}
					key={SportIcon.toString()}
					style={{ alignSelf: 'center' }}
					width={iconSizeLength}
				/>
			))}
		</S.IconsInnerView>
	);
};

namespace S {
	export const IconsInnerView = styled.div`
		display: flex;
		justify-content: space-around;
		margin-left: ${({ theme }) => theme.spacings.medium};
		margin-right: ${({ theme }) => theme.spacings.medium};
	`;
}
